export const topEarnClickAndHoverEvents = [
  {
    selector: '.mn_topEarn .mn_merchantTile',
    click: {
      category: 'Top earn rates',
      action: 'Tap merchant',
    },
    label: element => element.dataset.merchantName,
  },
];
